<template>
  <div class="animated fadeIn pt2 pb4">
    <div class="clearfix px2 mb2">
      <div class="col-12 px2">
        <allmeetings></allmeetings>
      </div>
    </div>
  </div>
</template>
<script>
import allmeetings from './AllMeetingsTable'
import Imentor from './imentor'
export default {
  components: {
    Imentor,
    allmeetings
  },
  data () {
    return {
      status: 'not_accepted'
    }
  }
}
</script>
<style>
.modal-body {
  padding: 5px!important;
}
.modal-header,
.modal-footer {
  border-top: 0;
  border-bottom: 0;
}
.fa-folder-open {
  font-size: 26px;
}
.meetingSort {
}
.searchContainer {
  position: relative;
  overflow: hidden;
}
.searchIcon {
  padding: 0.5rem;
}
.searchBox {
  border: 0;
  flex: 1;
  outline:none;
}
::-webkit-input-placeholder { /* Chrome/Opera/Safari */
  color: rgba(47, 54, 64, 0.5);
}
::-moz-placeholder { /* Firefox 19+ */
  color: rgba(47, 54, 64, 0.5);
}
:-ms-input-placeholder { /* IE 10+ */
  color: rgba(47, 54, 64, 0.5);
}
:-moz-placeholder { /* Firefox 18- */
  color: rgba(47, 54, 64, 0.5);
}



</style>



// WEBPACK FOOTER //
// AllMeetings.vue?83fd70d4